import { User } from '../models/User'
import { adminRoles, ownerRoles } from '../views/ManageTeam/InviteRoleGroups'
import { env } from './util'

export const isAdmin = (user?: User | null) => user?.roles.some((role) => role.id === adminRoles[env]) ?? false

export const isOwner = (user?: User | null) => user?.roles.some((role) => role.id === ownerRoles[env]) ?? false
